/* eslint-disable */
import Vue from 'vue'
import AMap from 'vue-amap'
import Router from 'vue-router'
import index from '@/components/index'
import about from '@/components/about/about'
import contact from '@/components/about/contact'
// 避免到当前位置的冗余导航
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)
export default new Router({
	mode:'history',
	routes: [{
			path: '/',
			name: 'index',
			component: index
		},
		{
			path: '/about/about',
			name: 'about',
			component: about
		},
		{
			path: '/about/contact',
			name: 'contact',
			component: contact
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js